export default "__VITE_PUBLIC_ASSET__24a034ad__"